import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Content from "../../../Components/Dashboard/Content/Content";

const BinanceGuide = () => {
    return (
        <Content
            Page_title="Binance API Key Setup"
            button_title="Back"
            Page_title_showClient="Complete step-by-step guide to create and manage your Binance API keys securely"
            route="/subadmin/apicreateinfo"
        >
            <div className="container pb-5 px-0 Api-Create-Info">
                {/* Header Section */}
                {/* <div className="mb-5">
                    <div className="card border-0 bg-gradient" style={{ background: 'linear-gradient(135deg, #f0b90b 0%, #f8d33a 100%)' }}>
                        <div className="card-body text-dark">
                            <h4 className="card-title mb-3">
                                <i className="fas fa-bitcoin me-3"></i>
                                Binance API Key Setup Guide
                            </h4>
                            <p className="card-text mb-0">
                                Complete step-by-step guide to create and manage your Binance API keys securely
                            </p>
                        </div>
                    </div>
                </div> */}

                {/* Step 1: Login to Binance */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-primary rounded-circle me-2">1</span>
                        Login to Binance
                    </h5>
                    <p className="fw-normal mb-3">
                        Go to{" "}
                        <a
                            href="https://www.binance.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-warning fw-bold"
                        >
                            https://www.binance.com/
                        </a>{" "}
                        and log into your account. Make sure your account is verified (KYC)
                        and you have enabled Two-Factor Authentication (2FA).
                    </p>

                    <div className="row mb-4">
                        <div className="col-lg-8">
                            <div className="card border-info">
                                <div className="card-body">
                                    <h6 className="card-title text-info">
                                        <i className="fas fa-info-circle me-2"></i>Prerequisites
                                    </h6>
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-check text-success me-2"></i>Valid Binance account</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Completed KYC verification</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Two-Factor Authentication (2FA) enabled</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=400&fit=crop"
                                alt="Binance Login Page"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-sign-in-alt fa-3x mb-2"></i>
                                <p className="mb-0">Binance Login Interface</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-primary">Login</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 2: Navigate to API Management */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-success rounded-circle me-2">2</span>
                        Navigate to API Management
                    </h5>
                    <p className="fw-normal mb-3">
                        After login, click your profile icon (top right), then select{" "}
                        <strong className="text-warning">"API Management"</strong> from the dropdown menu.
                    </p>

                    <div className="row mb-4">
                        <div className="col-lg-8">
                            <ol className="list-group list-group-numbered">
                                <li className="list-group-item d-flex align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">Profile Icon</div>
                                        Click on your profile avatar located at the top-right corner
                                    </div>
                                    <span className="badge bg-success rounded-pill">Step 1</span>
                                </li>
                                <li className="list-group-item d-flex align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">API Management</div>
                                        Select <strong className="text-warning">API Management</strong> from the dropdown
                                    </div>
                                    <span className="badge bg-success rounded-pill">Step 2</span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&h=400&fit=crop"
                                alt="Binance Profile Menu - API Management"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-user-cog fa-3x mb-2"></i>
                                <p className="mb-0">Profile Menu → API Management</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-success">Navigate</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 3: Create a New API Key */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-warning rounded-circle me-2">3</span>
                        Create a New API Key
                    </h5>
                    <p className="fw-normal mb-3">
                        Click on <strong className="text-warning">"Create API"</strong> button.
                        You will need to provide a label/name for your API key (e.g., "MyApp-Integration" or "Trading-Bot").
                    </p>

                    <div className="row mb-4">
                        <div className="col-lg-8">
                            <ol className="list-group list-group-numbered">
                                <li className="list-group-item d-flex align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">Create API Button</div>
                                        Click the <strong className="text-warning">Create API</strong> button on the API Management page
                                    </div>
                                    <span className="badge bg-warning rounded-pill">Step 1</span>
                                </li>
                                <li className="list-group-item d-flex align-items-start">
                                    <div className="ms-2 me-auto">
                                        <div className="fw-bold">Label Your API</div>
                                        Enter a descriptive name for your API key for easy identification
                                    </div>
                                    <span className="badge bg-warning rounded-pill">Step 2</span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&h=400&fit=crop"
                                alt="Binance Create API Key Interface"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-plus-circle fa-3x mb-2"></i>
                                <p className="mb-0">Create API Key Interface</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-warning">Create API</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 4: Complete Verification */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-info rounded-circle me-2">4</span>
                        Complete Security Verification
                    </h5>
                    <p className="fw-normal mb-3">
                        Complete the required security verification process:
                    </p>

                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="card border-info">
                                <div className="card-header bg-info text-white">
                                    <i className="fas fa-shield-alt me-2"></i>Verification Steps
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-envelope text-info me-2"></i>Email verification code</li>
                                        <li><i className="fas fa-mobile-alt text-success me-2"></i>SMS verification (if enabled)</li>
                                        <li><i className="fas fa-key text-warning me-2"></i>Google Authenticator / 2FA code</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1555421689-491a97ff2040?w=800&h=400&fit=crop"
                                alt="Binance Two Factor Authentication"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-lock fa-3x mb-2"></i>
                                <p className="mb-0">Security Verification Interface</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-info">Verify</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 5: Configure Permissions */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-secondary rounded-circle me-2">5</span>
                        Set Permissions and Restrictions
                    </h5>
                    <p className="fw-normal mb-3">
                        After API key creation, carefully configure the permissions you need:
                    </p>

                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="card border-success mb-3">
                                <div className="card-header bg-success text-white">
                                    <i className="fas fa-check-circle me-2"></i>Recommended Permissions
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-eye text-info me-2"></i>Read permissions</li>
                                        <li><i className="fas fa-chart-line text-primary me-2"></i>Enable Spot trading (if needed)</li>
                                        <li><i className="fas fa-exchange-alt text-secondary me-2"></i>Enable Margin trading (if required)</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card border-danger mb-3">
                                <div className="card-header bg-danger text-white">
                                    <i className="fas fa-exclamation-triangle me-2"></i>Security Recommendations
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-times-circle text-danger me-2"></i>Avoid withdrawal permissions</li>
                                        <li><i className="fas fa-globe text-warning me-2"></i>Use IP whitelist restrictions</li>
                                        <li><i className="fas fa-clock text-info me-2"></i>Set API key expiration</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1579952363873-27d3bfad9c0d?w=800&h=400&fit=crop"
                                alt="Binance API Permissions Settings"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-user-shield fa-3x mb-2"></i>
                                <p className="mb-0">API Permissions Configuration</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-secondary">Permissions</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 6: Copy and Store Keys */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-danger rounded-circle me-2">6</span>
                        Copy and Store Your Keys Securely
                    </h5>
                    <p className="fw-normal mb-3">
                        Once the API key is successfully created, you will receive:
                    </p>

                    <div className="alert alert-danger mb-4" role="alert">
                        <h6 className="alert-heading">
                            <i className="fas fa-exclamation-triangle me-2"></i>
                            Critical Security Warning
                        </h6>
                        <p className="mb-0">
                            <strong>⚠️ Important:</strong> The Secret Key will only be displayed once. Make sure to copy and store it securely immediately.
                        </p>
                    </div>

                    <div className="row mb-4">
                        <div className="col-md-6">
                            <div className="card border-primary">
                                <div className="card-body">
                                    <h6 className="card-title text-primary">
                                        <i className="fas fa-key me-2"></i>API Key (Public)
                                    </h6>
                                    <p className="card-text small text-muted">
                                        This can be shared and is used to identify your application.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card border-danger">
                                <div className="card-body">
                                    <h6 className="card-title text-danger">
                                        <i className="fas fa-lock me-2"></i>Secret Key (Private)
                                    </h6>
                                    <p className="card-text small text-muted">
                                        Keep this confidential. Never share or expose it publicly.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="screenshot-container mb-3">
                        <div className="position-relative">
                            <img
                                src="https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=800&h=400&fit=crop"
                                alt="Binance API and Secret Key Display"
                                className="img-fluid rounded shadow-sm border"
                                style={{ maxHeight: '300px', width: '100%', objectFit: 'cover' }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <div
                                className="bg-light border rounded p-4 text-center text-muted"
                                style={{ display: 'none' }}
                            >
                                <i className="fas fa-clipboard fa-3x mb-2"></i>
                                <p className="mb-0">API Key & Secret Display</p>
                            </div>
                            <div className="position-absolute top-0 start-0 m-2">
                                <span className="badge bg-danger">Copy Keys</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Step 7: Final Security Checklist */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-primary mb-3">
                        <span className="badge bg-dark rounded-circle me-2">7</span>
                        Final Security Checklist
                    </h5>
                    <p className="fw-normal mb-3">
                        Before using your API key in production, ensure all security measures are in place:
                    </p>

                    <div className="checklist">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check1" />
                                    <label className="ms-1 form-check-label" htmlFor="check1">
                                        <i className="fas fa-shield-alt text-success me-2"></i>
                                        Two-Factor Authentication (2FA) is active
                                    </label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check2" />
                                    <label className="ms-1 form-check-label" htmlFor="check2">
                                        <i className="fas fa-user-check text-info me-2"></i>
                                        Account verification (KYC) completed
                                    </label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check3" />
                                    <label className="ms-1 form-check-label" htmlFor="check3">
                                        <i className="fas fa-network-wired text-warning me-2"></i>
                                        IP restrictions configured (if applicable)
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check4" />
                                    <label className="ms-1 form-check-label" htmlFor="check4">
                                        <i className="fas fa-vault text-primary me-2"></i>
                                        Keys stored in secure vault/environment
                                    </label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check5" />
                                    <label className="ms-1 form-check-label" htmlFor="check5">
                                        <i className="fas fa-cog text-secondary me-2"></i>
                                        Permissions set to minimum required level
                                    </label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="check6" />
                                    <label className="ms-1 form-check-label" htmlFor="check6">
                                        <i className="fas fa-clock text-danger me-2"></i>
                                        API key expiration date set
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Security Best Practices */}
                <div className="step mb-5">
                    <h5 className="fw-bold text-danger mb-3">
                        <i className="fas fa-shield-alt me-2"></i>
                        Security Best Practices
                    </h5>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card border-success">
                                <div className="card-header bg-success text-white">
                                    <i className="fas fa-check-circle me-2"></i>Do's
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-check text-success me-2"></i>Use unique, descriptive API names</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Enable IP whitelisting</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Store keys in encrypted vaults</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Regularly rotate API keys</li>
                                        <li><i className="fas fa-check text-success me-2"></i>Monitor API usage regularly</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card border-danger">
                                <div className="card-header bg-danger text-white">
                                    <i className="fas fa-times-circle me-2"></i>Don'ts
                                </div>
                                <div className="card-body">
                                    <ul className="list-unstyled mb-0">
                                        <li><i className="fas fa-times text-danger me-2"></i>Never share your secret keys</li>
                                        <li><i className="fas fa-times text-danger me-2"></i>Don't enable withdrawal without necessity</li>
                                        <li><i className="fas fa-times text-danger me-2"></i>Avoid storing keys in plain text</li>
                                        <li><i className="fas fa-times text-danger me-2"></i>Don't use same keys across platforms</li>
                                        <li><i className="fas fa-times text-danger me-2"></i>Never commit keys to repositories</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}

                {/* Final Notice */}
                <div className="alert alert-info" role="alert">
                    <h6 className="alert-heading">
                        <i className="fas fa-lightbulb me-2"></i>Pro Tip
                    </h6>
                    <p className="mb-0">
                        Always test your API integration in Binance Testnet first before using it in production.
                        This helps ensure your implementation works correctly without risking real funds.
                    </p>
                </div>
            </div>
        </Content>
    );
};

export default BinanceGuide;